import { render, staticRenderFns } from "./newDirectionsDetail.vue?vue&type=template&id=1a95f98f&scoped=true&"
import script from "./newDirectionsDetail.vue?vue&type=script&lang=js&"
export * from "./newDirectionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./newDirectionsDetail.vue?vue&type=style&index=0&id=1a95f98f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95f98f",
  null
  
)

export default component.exports